import React, { useState } from "react";
import axios from "axios";


const useLabel = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const mainApi = '/koha/item/label'
    const [data, setData] = useState([])

    const getLabelData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postLabelData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data,
            { responseType: 'blob' }
        )
            .then((response) => {
                let label = "條碼標籤"
                if (data?.type === "barcode") {
                    label = "條碼標籤"
                }
                else {
                    label = "書碼標籤"
                }
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${label}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                onFinish(
                    {
                        axiosMode: "post",
                        status: "success"
                    }
                )
            })

    }
    const patchLabelData = (data) => {

        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,

            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteLabelData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        labelData: data,
        getLabelData,
        postLabelData,
        patchLabelData,
        deleteLabelData,
    }
}
export { useLabel }
